import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useTeamMemberCount = (teamId: number) => {
  const [memberCount, setMemberCount] = useState<number>(0);
  const [playerCount, setPlayerCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMemberCount = async () => {
      try {
        // Get players count
        const { count: playersCount, error: playersError } = await supabase
          .from('team_players')
          .select('*', { count: 'exact', head: true })
          .eq('team_id', teamId);

        if (playersError) {
          console.error('Error fetching players count:', playersError);
        }

        // Get coaches count
        const { count: coachesCount, error: coachesError } = await supabase
          .from('team_coaches')
          .select('*', { count: 'exact', head: true })
          .eq('team_id', teamId);

        if (coachesError) {
          console.error('Error fetching coaches count:', coachesError);
        }

        // Get support staff count
        const { count: supportCount, error: supportError } = await supabase
          .from('team_support_staff')
          .select('*', { count: 'exact', head: true })
          .eq('team_id', teamId);

        if (supportError) {
          console.error('Error fetching support staff count:', supportError);
        }

        const totalPlayers = playersCount || 0;
        const totalCoaches = coachesCount || 0;
        const totalSupport = supportCount || 0;
        const totalMembers = totalPlayers + totalCoaches + totalSupport;

        setPlayerCount(totalPlayers);
        setMemberCount(totalMembers);
        
        console.log(`Team ${teamId} - Players: ${totalPlayers}, Coaches: ${totalCoaches}, Support: ${totalSupport}, Total: ${totalMembers}`);
      } catch (error) {
        console.error('Error fetching team member count:', error);
        setMemberCount(0);
        setPlayerCount(0);
      } finally {
        setLoading(false);
      }
    };

    if (teamId) {
      fetchMemberCount();
    }
  }, [teamId]);

  return { memberCount, playerCount, loading };
};